import { useEffect, useState } from 'react';
import { adminGetMyAccess, hasPermission } from '../services/adminAccess';

// Shared "what can I do" hook for the Mentor/Manager/Support workspaces and
// AdminSidebar's nav-item visibility (docs/DECISIONS.md, "RUDVAN Admin
// Module: internal staff, RBAC, student-mentor allocation" Phase 4-6).
// AdminStaff.jsx/AdminRoles.jsx/AdminStudents.jsx (Phase 0-3) each fetch
// GET /api/admin/me inline instead of through this hook - left as-is
// (already working, already tested) rather than retrofitted, to keep this
// pass's changes additive.
export default function useAdminAccess() {
  const [state, setState] = useState('loading'); // loading | ok | error
  const [access, setAccess] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const result = await adminGetMyAccess();
        if (!cancelled) {
          setAccess(result);
          setState('ok');
        }
      } catch (error) {
        if (!cancelled) setState('error');
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const can = (permission) => hasPermission(access, permission);

  return { state, access, can };
}
